import * as ActionTypes from './../actionTypes';


const reducer = (state = {}, action) => {
    switch (action.type) {
        case ActionTypes.SELECT_BOARD2:
            return {
                ...state,
                boardId: action.boardId,
                boardName: action.boardName,
                classId: '',
                className: '',
                groupId: '',
                groupName: '',
                questionTarget: "Normal"
            }

        case ActionTypes.SELECT_CLASS2:
            return {
                ...state,
                classId: action.classId,
                className: action.className,
                groupId: '',
                groupName: '',
            }

        case ActionTypes.SELECT_GROUP2:
            return {
                ...state,
                groupId: action.groupId,
                groupName: action.groupName

            }

        case ActionTypes.SELECT_SUBJECT2:
            return {
                ...state,
                subjectId: action.subjectId,
                subjectName: action.subjectName

            }

        case ActionTypes.SELECT_MULTIPLE_SUBJECTS2:
            return {
                ...state,
                subjectsMultipleSelected: [
                    action.subjects
                ]

            }
        case ActionTypes.SELECT_TOPIC2:
            return {
                ...state,
                topicId: action.topicId,
                topicName: action.topicName

            }
        case ActionTypes.SELECT_MULTIPLE_TOPICS2:
            return {
                ...state,
                topicsMultipleSelected: [
                    action.topics
                ]
            }
        case ActionTypes.SELECT_CHAPTER2:
            return {
                ...state,
                chapterId: action.chapterId,
                chapterName: action.chapterName,
            }
        case ActionTypes.SELECT_QUESTION_TARGET2:
            return {
                ...state,
                questionTarget: action.questionTarget,
            }
        case ActionTypes.SELECT_MULTIPLE_CHAPTERS2:
            return {
                ...state,
                chaptersMultipleSelected: [
                    action.chapters
                ]
            }
        case ActionTypes.CLEAR_SELECTED_ORGANIZATION_DATA2:
            return {}
        case ActionTypes.CLEAR_SELECTED_ORGANIZATION_DATA_SELECTIONS2:
            return {
                ...state,
                boardId: null,
                boardName: null,
                classId: null,
                className: null,
                groupId: null,
                groupName: null,
            }
        default: return state
    }
}

export default reducer;